module.exports = __webpack_public_path__ + "static/media/about.7565409d.md";